<template>
  <div>
    <Header title="留言" type="0" route="/processEvaluation/index"></Header>
    <div class="conten">
      <p>学年学期:{{this.dataList}}</p>
      <p>课程:{{this.infoList.kcmc}}</p>
      <p>教师:{{this.infoList.jsxm}}[{{this.infoList.jgh}}]</p>
    </div>
    <div class="record">
      <span>留言记录</span>
      <div class="ly">
        <div class="recordBox" v-for="(item,index) in lyData" :key="index">
          <div class="time">
            {{item.lysj}}
          </div>
          <div class="role">
            {{item.lyr}}{{item.cstr}}{{item.hfr}}{{item.cstr2}}:
          </div>
          <div class="chat">
            <p>留言内容:</p>
            <p>{{item.lynr}}</p>
          </div>
          <van-button type="primary" @click="goBottom(item)">回复</van-button>
        </div>
      </div>
    </div>
    <div class="publish">
      <van-field rows="3" colon autosize :label="remarklabel" type="textarea" v-model="dqlynr"/>
      <van-checkbox v-model="checked">仅教师可见</van-checkbox>
    </div>
    <div class="bottomButton">
      <button v-if="isCanSubmit" type="primary" @click="getxslySave">发送</button>
    </div>
  </div>
</template>

<script>
  import {Api} from "@/utils/axios";
  export default{
    data(){
      return{
        dataList: '',
        infoList:'',
        value:'',
        checked:false,
        lyData:[],
        remarklabel: '留言',
        lytype:1,
        dqlynr:'',
        pid:'',
        dqxq: ''
      }
    },
    computed:{
      isCanSubmit() {
        return this.dataList == this.dqxq
      }
    },
    created() {
      this.dataList = this.$route.query.xqvalue;
      console.log('this.dataList:', this.dataList);
      this.infoList = this.$route.query.item;
      console.log('this.infoList:', this.infoList);
      this.getNewxsly();
    },
    methods:{
      async getNewxsly(){
        const res =await Api.newxsly({
          jg0101id:this.infoList.jg0101id,
          jx0404id:this.infoList.jx0404id
        });
        this.lyData = res.data.lylist;
        this.dqxq =res.data.dqxnxq
        console.log('this.lyData:',this.lyData);
      },
      goBottom(item){
        window.scrollTo(0, document.documentElement.scrollHeight-document.documentElement.clientHeight);
        this.remarklabel = item.lyr;
        this.lytype = 2;
        this.pid = item.id;
        console.log('item:',item);
        console.log('this.lytype:',this.lytype);
        console.log('this.pid:',this.pid);
      },
      async getxslySave(){
        if (!this.isCanSubmit) return
        const obj={
          lyType:this.lytype,
          isJsOnly:this.checked,
          dqlynr:this.dqlynr,
          pid:this.pid,
          jx0404id:this.infoList.jx0404id,
          jg0101id:this.infoList.jg0101id
        }
        const result = await Api.xslySave(obj);
        console.log('result:',result)
        console.log('obj:',obj.pid)
        if(result.Msg == '成功'){
          this.getNewxsly();
          this.remarklabel = '留言';
          this.dqlynr = '';
          this.checked = false
        }
      }
    }
  }
</script>

<style scoped lang="less">
  .conten {
    margin-top: 60px;
    margin-left: 24px;
    background-color: #DFE0E6;
  }

  .conten p {
    padding: 5px 0;
  }
  .chat{
    width: 100%;
    border: 1px solid #DFE0E6;
    word-wrap:break-word ;
  }
  .van-field__label{
    width: 50px;
  }
  .van-button{
    width: 60px;
    background-color: #7469F8;
  }
  .publish{
    margin-top: 20px;
    margin-left: 24px;
  }
  .van-field {
    border: 1px solid #000000;
  }
  .van-field__label{
    width: 50px;
  }
  .record{
    margin-top: 20px;
    margin-left: 24px;
  }
  .record>span{
    font-size: 20px;
    color: #000000;
    font-weight: 600;
  }
  .ly{
    border: 1px solid #000000;
    margin: 10px 0;
  }
  .recordBox{
    margin: 10px 0;
  }
  .recordBox >div{
    margin: 10px 0;
  }
  .reply{
    margin-top: 20px;
    margin-left: 24px;
  }
  .bottomButton {
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .bottomButton > button {
    width: 50px;
    height: 50px;
    margin: 10px;
    background-color: #7469F8;
  }
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/dialogue/index.vue